import { Component, OnInit, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-confirm.dialog',
  templateUrl: './confirm.dialog.component.html',
  styleUrl: './confirm.dialog.component.scss',
})
export class ConfirmDialogComponent implements OnInit {
  private config = inject(DynamicDialogConfig);
  private ref = inject(DynamicDialogRef);

  message!: string;

  ngOnInit(): void {
    this.message = this.config.data.message;
  }

  onClick(confirm: boolean): void {
    this.ref.close(confirm);
  }
}
